import Layout from '../Components/Layout/Layout';

const Terms = () => {
    return (
        <Layout>
        <div className="max-w-4xl mx-auto px-4 py-0 md:py-8">
                <h1 className="text-2xl font-bold text-ps-blue-dark mb-8">Gebruiksvoorwaarden PS in foodservice</h1>
                <div className="prose prose-sm max-w-none">
                    <div className="bg-white p-0 space-y-8">
                        <p className="text-gray-600 leading-relaxed">
                            De Diensten PS in foodservice worden bij wijze van Software-as-a-Service aangeboden. Aan het gebruik van de Diensten en Digitale producten zijn Gebruiksvoorwaarden verbonden. Om de Diensten en Digitale producten te gebruiken, dient akkoord gegaan te worden met deze voorwaarden. Afwijkingen van deze Gebruiksvoorwaarden zijn alleen bindend indien deze door Aanbieder schriftelijk zijn aanvaard.
                        </p>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 1 – Definities</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li><strong>Aanbieder:</strong> PS in foodservice is een handelsnaam van ProductSpecs4all BV, geregistreerd bij de Kamer van Koophandel onder nummer 09088933.</li>
                                <li><strong>Afnemer:</strong> De natuurlijk persoon of rechtspersoon al dan niet handelend in de uitoefening van beroep of bedrijf die de Diensten afneemt van Aanbieder.</li>
                                <li><strong>AVG:</strong> Algemene Verordening Gegevensbescherming.</li>
                                <li><strong>Webapplicatie:</strong> De applicatie voor Eindgebruikers om ingrediënten van gerechten of dranken inzichtelijk te maken op het gebied van voedsel-, allergenen- en productinformatie.</li>
                                <li><strong>Beheerder:</strong> Een Gebruiker met beheerdersrechten die door de Aanbieder is benoemd tot Beheerder van het Beheerdersportaal.</li>
                                <li><strong>Beheerdersportaal:</strong> De dashboardomgeving van de Aanbieder waar alle instellingen en statistieken beheerd kunnen worden door Beheerder(s).</li>
                                <li><strong>Database:</strong> De database van PS in foodservice waarin zijn opgeslagen alle Voedsel-, Allergenen- en Productinformatie.</li>
                                <li><strong>Diensten:</strong> De webapplicatie waarmee Gebruikers worden geïnformeerd over voedsel-, allergenen- en productinformatie.</li>
                                <li><strong>Digitaal producten:</strong> Een Database met voedsel-, allergenen- en productinformatie.</li>
                                <li><strong>Derden:</strong> Anderen dan Aanbieder, Afnemer en Gebruikers.</li>
                                <li><strong>Eindgebruiker:</strong> De feitelijke (natuurlijk) persoon die van de Diensten gebruik maakt.</li>
                                <li><strong>Gebruiker(s):</strong> De feitelijke (natuurlijk) persoon die van de Diensten gebruik maakt.</li>
                                <li><strong>Gebruiksvoorwaarden:</strong> De onderhavige voorwaarden.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 2 – Omschrijving van de Diensten en Digitale producten</h2>
                            <div className="space-y-4 text-gray-600">
                                <p>De Diensten van Aanbieder:</p>
                                <ul className="list-disc pl-5">
                                    <li>Een webapplicatie voor Eindgebruikers om ingrediënten van gerechten of dranken inzichtelijk te maken.</li>
                                </ul>
                                <p>De Digitale producten van Aanbieder:</p>
                                <ul className="list-disc pl-5">
                                    <li>Een Database met voedsel-, allergenen- en productinformatie</li>
                                </ul>
                                <p>De Diensten worden gezamenlijk of afzonderlijk in opdracht van Eindgebruiker geleverd door Aanbieder.</p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 3 – Gebruik</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Afnemer en Eindgebruiker dienen de webapplicatie uitsluitend voor beroep en bedrijfsdoeleinden te gebruiken.</li>
                                <li>Door het gebruik van de webapplicatie aanvaardt de Eindgebruiker deze Gebruiksvoorwaarden.</li>
                                <li>Om van de webapplicatie gebruik te kunnen maken, dient de Eindgebruiker zelf zorg te dragen voor de noodzakelijke apparatuur en internetverbinding.</li>
                                <li>Aanbieder verstrekt aan Eindgebruiker een niet-exclusief gebruiksrecht.</li>
                                <li>Het gebruiksrecht eindigt bij beëindiging van de Overeenkomst of deactivering van het account.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 4 – Registratie</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Eindgebruiker dient 18 jaar of ouder te zijn om te registreren.</li>
                                <li>Een account is beperkt tot één bedrijf.</li>
                                <li>Eindgebruiker is verantwoordelijk voor het instellen en gebruik van de Diensten.</li>
                                <li>Eindgebruiker is verantwoordelijk voor het geheimhouden van inloggegevens.</li>
                                <li>Bij misbruik kan Aanbieder het account deactiveren.</li>
                            </ul>
                        </section>
                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 5 – De-installatie Webapplicatie</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>De webapplicatie kan te allen tijde worden verwijderd.</li>
                                <li>Bij verwijdering worden de persoonsgegevens met betrekking tot die Eindgebruiker verwijderd.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 6 – Gebruiksregels</h2>
                            <div className="space-y-4 text-gray-600">
                                <p>Het is verboden de Diensten te gebruiken voor:</p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>Handelingen in strijd met Nederlandse wetgeving</li>
                                    <li>Het verspreiden van smadelijke, lasterlijke of racistische informatie</li>
                                    <li>Het verspreiden van bestanden in strijd met auteurswetgeving</li>
                                </ul>
                                <p>Aanbieder mag zonder waarschuwing ingrijpen bij overtredingen.</p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 7 – Broncode</h2>
                            <p className="text-gray-600">
                                Eindgebruiker erkent dat de broncode eigendom is van PS in foodservice. Het is niet toegestaan de broncode te wijzigen, aan te passen, te vertalen, te reverse-engineeren of te decompileren.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 8 – Notice en takedown</h2>
                            <p className="text-gray-600">
                                Bij inbreuk op rechten of onrechtmatig handelen mag PS in foodservice de dienst afsluiten en content verwijderen. PS in Foodservice is niet aansprakelijk voor schade ten gevolge van deze maatregelen.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 9 – Intellectueel eigendom</h2>
                            <p className="text-gray-600">
                                De Diensten, webapplicatie, Database en alle informatie zijn intellectueel eigendom van Aanbieder en mogen niet worden gekopieerd zonder schriftelijke toestemming.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 10 – Geheimhouding</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Vertrouwelijke informatie wordt als zodanig behandeld</li>
                                <li>Benchmark data mag worden gegenereerd met toestemming</li>
                            </ul>
                        </section>
                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 11 – Privacy en beveiliging</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Persoonsgegevens worden verwerkt volgens de AVG</li>
                                <li>Verwerking gebeurt conform de privacy- en cookieverklaring</li>
                                <li>Aanbieder zorgt voor passende beveiliging</li>
                                <li>Er is een verwerkersovereenkomst voor persoonsgegevens</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 12 – Toegang en gebruik</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>PS in foodservice biedt alleen de webapplicatie aan</li>
                                <li>Weergegeven informatie is onder voorbehoud van fouten</li>
                                <li>Eindgebruiker moet noodzakelijke gegevens verstrekken</li>
                                <li>PS in foodservice is niet aansprakelijk voor schade door onjuiste gegevens</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 13 – Ondersteuning en onderhoud</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Aanbieder spant zich in voor continue beschikbaarheid</li>
                                <li>Ondersteuning via website en e-mail</li>
                                <li>Onderhoud wordt waar mogelijk vooraf aangekondigd</li>
                                <li>Aanbieder mag functionaliteit aanpassen</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 14 – Garanties en aansprakelijkheid</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Geen garanties voor ongestoorde werking</li>
                                <li>Eindgebruiker verantwoordelijk voor internetverbinding</li>
                                <li>Gebruik voor eigen risico</li>
                                <li>Aanbieder niet aansprakelijk voor indirecte schade</li>
                                <li>Overmacht sluit aansprakelijkheid uit</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 15 – Vergoeding voor de Diensten</h2>
                            <p className="text-gray-600">
                                Aan het gebruik van de Digitale Producten kan een vergoeding worden verbonden zoals gespecificeerd in de Onderliggende Overeenkomst.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 16 – Duur en wijzigingen Gebruiksvoorwaarden</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Geldig tijdens gebruik van de Diensten</li>
                                <li>Wijzigingen worden aangekondigd</li>
                                <li>Gebruik na wijziging geldt als acceptatie</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 17 – Communicatie</h2>
                            <p className="text-gray-600">
                                Door gebruik van de webapplicatie stemt Eindgebruiker in met communicatie via alle mogelijke kanalen. Uitschrijven kan via info@psinfoodservice.com.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Artikel 18 – Overige bepalingen</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Nederlands recht van toepassing</li>
                                <li>Geschillen voor de bevoegde Nederlandse rechter</li>
                                <li>Communicatie door Aanbieder wordt geacht juist te zijn</li>
                                <li>Nietige bepalingen tasten niet gehele overeenkomst aan</li>
                                <li>Rechten overdraagbaar bij overname</li>
                            </ul>
                        </section>

                        <div className="mt-8 text-sm text-gray-500">
                            <p>Ede, 1 december 2024</p>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Terms;